import { ArrowLeft, LineChart } from "lucide-react";
import React, { useState } from "react";
import {
  ActionIcon,
  Drawer,
  Group,
  ScrollArea,
  Space,
  Text,
} from "@mantine/core";
import ExportSurveyButton from "./ExportSurveyButton";
import SurveyReportModel from "../components/SurveyReportModel";

type ViewAnnouncementStatsActionIconProps = {
  id: number;
  title: string;
};

const ViewSurveyActionIcon: React.FC<ViewAnnouncementStatsActionIconProps> = ({
  id,
  title,
}) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        size="full"
        onClose={() => setOpened(false)}
        styles={{
          header: {
            backgroundColor: "#ffffff",
          },
          title: { width: "100%" },
          drawer: {
            backgroundColor: "#f7f7f8",
          },
        }}
        title={
          <Group
            position="apart"
            spacing="xl"
            style={{
              width: "100%",
            }}
          >
            <Group spacing="xl">
              <ActionIcon onClick={() => setOpened(false)}>
                <ArrowLeft />
              </ActionIcon>

              <Text>{title}</Text>
            </Group>
            <ExportSurveyButton id={id} asButton />
          </Group>
        }
        overlayOpacity={0.1}
        overlayBlur={3}
        withCloseButton={false}
        position="right"
      >
        <ScrollArea
          style={{
            backgroundColor: "#f7f7f8",
            height: "850px",
          }}
        >
          <SurveyReportModel id={id} />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
        </ScrollArea>
      </Drawer>

      <ActionIcon onClick={() => setOpened(true)}>
        <LineChart size={18} />
      </ActionIcon>
    </>
  );
};

export default ViewSurveyActionIcon;
